import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ValidatorFn } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss']
})
export class PromptComponent implements OnInit {

  options: { text: string, value: any, cssClass: string }[];
  title: string;
  message: string;
  form: UntypedFormGroup;
  response: UntypedFormControl;
  buttonSubmitText: string = 'Ok'

  @Input() validators: ValidatorFn | ValidatorFn[] = [];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.response = new UntypedFormControl('', this.validators);
    this.form = new UntypedFormGroup({ response: this.response });
  }

  setMessage(message: string | Array<string>) {
    const messageMerge = message instanceof Array ? message.join('<br>') : message;
    this.message = messageMerge;
  }

}
